import classNames from "classnames";
import { PropsWithChildren, useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styles from "./navigation-button.module.scss";

type Props = PropsWithChildren<{
  text: string;
  link: string;
}>;

export const NavigationButton = ({ text, link, children }: Props) => {
  const location = useLocation();

  const isActive = useMemo(() => {
    const locationUrl = location.pathname.split("/")[3];

    return (!locationUrl && !link) || locationUrl === link;
  }, [link, location.pathname]);

  return (
    <li className={classNames(styles.button, isActive && styles.active)}>
      <NavLink to={link} className={styles.link}>
        {children}
        <span className={styles.text}>{text}</span>
      </NavLink>
    </li>
  );
};
